import api from "./axiosInstance";

// 1️⃣ Get OTP
export const requestOtp = async (email, password) => {
  const res = await api.post("api/v1/account/auth/request-otp/", {
    email,
    password,
  });
  return res.data;
};

// 2️⃣ Verify OTP & Sign In
export const verifyOtp = async (email, otp, token) => {
  const res = await api.post("api/v1/account/auth/verify-otp/", {
    otp_token: token,
    email,
    code: otp,
  });
  console.log('---', res.data);
  return res.data;
};

// 3️⃣ Request Password Reset
export const requestPasswordReset = async (email) => {
  const res = await api.post("api/v1/account/auth/password-reset/request/", {
    email,
  });
  return res.data;
}

// 4️⃣ Reset Password
export const resetPassword = async (newPassword, token) => {
  const res = await api.post("api/v1/account/auth/password-reset/confirm/", {
    new_password: newPassword,
    otp_token: token,
  });
  return res.data;
}
